import { useNavigate } from 'react-router-dom';
//import logoPositiv from '../img/asg aufmassdienst-positive.png';
//import logoNegativ from '../img/asg aufmassdienst-negative.png';
import logoBlue from '../img/asg-aufmassdienst-blue-bg.png';

interface ThisProps {
  //  auftragUid: string,
}

const LogoComponent: React.FC<ThisProps> = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <img
        style={{height: "6em"}}
        alt="image" 
        src={window.location.pathname === '/' ? logoBlue : logoBlue}
        onClick={() => {
          navigate({
            pathname: '/'
          })
        }}
      />
    </>
  );
}

export default LogoComponent;
